import { CircularProgress } from '@mui/material';
import { ReactComponent as ChartLine } from 'images/shared/chart-line-4.svg';
import { EmptyListWrapper } from './style';
import { EmptyState } from 'ihp-components/components/v2/EmptyState';

export const EmptyList = ({
  isLoading = false,
}) => {
    let title = isLoading ? 'Loading Education Materials' : 'No records to display';
    let subtitle =  isLoading
    ? 'It may take a few moments to complete'
    : 'Try Removing some of the filters applied in the filter panel to view more records';
    let icon = <ChartLine />;
    if (isLoading) {
      icon = null;
    } else {
      icon = <ChartLine />;
    }
  return (
    <EmptyListWrapper>
      <EmptyState icon={icon} title={title} description={subtitle} />
      {isLoading && (
        <CircularProgress sx={{ marginTop: '20px' }} color='primary' />
      )}
    </EmptyListWrapper>
  );
};
